module.exports = __webpack_public_path__ + "img/pic-1.f1809950.png";